<h3 class="header">{{ header }}</h3>
<div class="customers">
  <div class="customers__logo">
    <!-- <a target="_blank" *ngFor="let customer of customers" [routerLink]="customer.link"></a> -->
    <a target="_blank" *ngFor="let customer of customers">
      <img *ngIf="customer.logo" src="{{ customer.logo }}" alt="{{ customer.name }}" loading="lazy"
      />
      <div class="description">
        <p>{{customer.description}}</p>
      </div>
  </a>
  </div>
</div>
